import { z } from "zod";
import {
  AMOUNT_1,
  AMOUNT_10,
  AMOUNT_11,
  AMOUNT_12,
  AMOUNT_2,
  AMOUNT_3,
  AMOUNT_4,
  AMOUNT_5,
  AMOUNT_6,
  AMOUNT_7,
  AMOUNT_8,
  AMOUNT_9,
} from "./consts";

export const schema = z.object({
  [AMOUNT_1]: z.string().optional(),
  [AMOUNT_2]: z.string().optional(),
  [AMOUNT_3]: z.string().optional(),
  [AMOUNT_4]: z.string().optional(),
  [AMOUNT_5]: z.string().optional(),
  [AMOUNT_6]: z.string().optional(),
  [AMOUNT_7]: z.string().optional(),
  [AMOUNT_8]: z.string().optional(),
  [AMOUNT_9]: z.string().optional(),
  [AMOUNT_10]: z.string().optional(),
  [AMOUNT_11]: z.string().optional(),
  [AMOUNT_12]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
